import { NavStepper, NavStepperItem } from '@spotify-internal/encore-web';

type OnboardingProgressProps = {
  steps: readonly string[];
  currentStep: number;
  currentStepProgress?: string;
};

export const OnboardingProgress = ({
  steps,
  currentStep,
  currentStepProgress,
}: OnboardingProgressProps) => (
  <NavStepper aria-label="Setup progress">
    {steps.map((step, index) => (
      <NavStepperItem
        key={step}
        active={index === currentStep}
        visited={index < currentStep}
      >
        {index === currentStep && currentStepProgress
          ? `${step} · ${currentStepProgress}`
          : step}
      </NavStepperItem>
    ))}
  </NavStepper>
);
